/**
 *
 */

import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Row, Col, Icon } from 'antd';
import LandingContainer from '../../components/LandingContainer';
import endPoints from '../../config/endPoints';
import { constants } from '../../devUtils';
import { SubTitle } from '../../components';

const StyledJourney = styled.section`
  background:${({ theme }) => theme.webGray};
  .sub-tile{
    font-size: 38px;
    line-height: 50px;
    font-weight: 900 !important;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
    .sub-tile{
      font-size:30px;
      line-height: 40px;
      font-weight: 900 !important
    }
    .ant-btn{
      margin: 10px 0px;
    }
  };
  .inner-round{
    background: ${({ theme }) => theme.whiteColor};
    border-radius: 130px 0px 0px 0px;
    border: solid 1px ${({ theme }) => theme.primaryColor};
    border-right: none;
    padding:80px 0px;
  }
  @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
    img{
      width: 100% !important;
    }
  };
`;

function LandingJourney() {
  return (
    <StyledJourney>
      <div className="inner-round">
        <LandingContainer>
          <Row align="middle" type="flex" gutter={16}>
            <Col xs={24} sm={24} md={10} lg={10} xl={10} className="text-left">
              <SubTitle className="sub-tile">Let’s talk about how <br />we can grow your <br />business</SubTitle>
              <Link to={constants.LINK_CONTACTUS} className="btn red-btn">CONNECT WITH EXPERT NOW <Icon type="right" /></Link>
            </Col>
            <Col xs={24} sm={24} md={14} lg={14} xl={14}>
              <img
                src={endPoints.ZAGGLE_JOURNEY.URL}
                alt={endPoints.ZAGGLE_JOURNEY.ALT}
                className="width-100 height-auto"
                height={2102}
                width={802}
              />
            </Col>
          </Row>
        </LandingContainer>
      </div>
    </StyledJourney>
  );
}

export default LandingJourney;



// WEBPACK FOOTER //
// client/containers/NewLanding/Journey.jsx